export default "__VITE_PUBLIC_ASSET__e6e87ba8__"